<template xmlns="http://www.w3.org/1999/html">
    <b-modal v-model="visible" size="lg">
        <template v-slot:modal-header="{ close }">
            <div class="row" style="width: 100%">
                <div class="col-md-10 offset-md-1 text-center d-flex justify-content-center">
                    <h3> {{ __('assign_to_group') }} </h3>
                </div>
                <div class="col-md-1">
                    <button type="button" class="close" v-on:click="visible = false">
                        <span aria-hidden="true">&times;</span>
                        <span class="sr-only">{{ __('close') }}</span>
                    </button>
                </div>
            </div>
        </template>

        <template v-slot:default="{}">
            <div class="row">
                <div class="col-4">
                    <select2 style="width: 100%" class="" v-model="assignToGroup" :options="groups"
                             :settings="{ width: '100%' }"></select2>
                </div>
            </div>

        </template>
        <template v-slot:modal-footer="{}">
            <div class="row m-b">
                <div class="col-md-12 text-right">
                    <div class="modal-footer">

                        <button type="button" @click="visible = false" class="btn btn-white">{{ __('cancel') }}</button>
                        <button v-if="assignToGroup != 0" type="button" @click="handleAssignToGroup()"
                                class="btn btn-primary">{{ __('OK') }}
                        </button>
                    </div>
                </div>
            </div>
        </template>
    </b-modal>
</template>

<script>
export default {
    name: "ModalAssignToContractorGroup",
    data: function () {
        return {
            visible: false,
            assignToGroup: 0,
        }
    },
    props: {
        contractorsAndGroups: {
            type: Array,
            default: [],
        }
    },
    methods: {
        handleAssignToGroup: function () {
            let contractorsToAssign = [];
            this.contractorsAndGroups.forEach(group => {
                for (let i = group.contractors.length - 1; i >= 0; i--) {
                    const contractor = group.contractors[i];
                    if (contractor.checked) {
                        contractor.checked = false
                        contractorsToAssign.push(contractor);
                        group.contractors.splice(i, 1);
                    }
                }
            });
            let targetIndex = this.contractorsAndGroups.findIndex(item => {
                return item.name == this.assignToGroup;
            })
            for(let i = 0; i <= contractorsToAssign.length - 1; i++){
                this.contractorsAndGroups[targetIndex].contractors.push(contractorsToAssign[i])
            }
            this.visible = false;
            return this.contractorsAndGroups
        }
    },
    computed: {
        groupsWithoutUnallocated: function () {
            return this.contractorsAndGroups.filter(group => group.name != 'unallocated')
        },
        groups() {
            let options = [];
            options.push({text: '---', 'id': 0})
            for (var i = 0; i <= this.groupsWithoutUnallocated.length - 1; i++) {
                options.push({text: this.groupsWithoutUnallocated[i].name, 'id': this.groupsWithoutUnallocated[i].name})
            }

            return options
        },
    },

}
</script>

<style scoped>

</style>
